window.LaurelDelivery = (function () {
  var SLOTS = ['9am - 6pm', '9am - 12pm', '12pm - 3pm', '3pm - 6pm'];
  var ALIASES = {
    '*': '*',
    morning: '9am - 12pm',
    midday: '12pm - 3pm',
    afternoon: '3pm - 6pm',
    standard: '9am - 6pm',
    '9am - 6pm': '9am - 6pm',
    '9am - 12pm': '9am - 12pm',
    '12pm - 3pm': '12pm - 3pm',
    '3pm - 6pm': '3pm - 6pm',
  };

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function toYmd(date) {
    return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
  }

  function toDmy(date) {
    return pad(date.getDate()) + '-' + pad(date.getMonth() + 1) + '-' + date.getFullYear();
  }

  function parseDates(raw) {
    if (!raw) return [];
    var text = raw;
    if (Array.isArray(raw)) {
      return raw.map(String).map(function (s) { return s.trim(); }).filter(Boolean);
    }
    try {
      var parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      if (Array.isArray(parsed)) {
        return parsed.map(String).map(function (s) { return s.trim(); }).filter(Boolean);
      }
      text = String(parsed);
    } catch (e) {
      text = String(raw);
    }
    return String(text)
      .replace(/^"|"$/g, '')
      .split(/[,\n]+/)
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  function normalizeSlot(name) {
    var key = String(name || '').trim().toLowerCase();
    return ALIASES[key] || ALIASES[String(name || '').trim()] || String(name || '').trim();
  }

  function parseSlotLines(raw) {
    var map = {};
    String(raw || '')
      .split(/\n+/)
      .map(function (s) { return s.trim(); })
      .filter(Boolean)
      .forEach(function (line) {
      if (line.indexOf('|') === -1) return;
      var parts = line.split('|');
      var dateKey = (parts[0] || '').trim();
      var slotsRaw = (parts.slice(1).join('|') || '').trim();
      if (!dateKey) return;
      var slots = slotsRaw === '*'
        ? ['*']
        : slotsRaw.split(',').map(normalizeSlot).filter(Boolean);
      if (!map[dateKey]) map[dateKey] = [];
      slots.forEach(function (slot) {
        if (map[dateKey].indexOf(slot) === -1) map[dateKey].push(slot);
      });
    });
    return map;
  }

  function dateKeys(dateOrText) {
    if (dateOrText instanceof Date) {
      return [toYmd(dateOrText), toDmy(dateOrText)];
    }
    var text = String(dateOrText || '').trim();
    var keys = [text];
    var parts = text.split('-');
    if (parts.length === 3) {
      if (parts[0].length === 4) {
        keys.push(parts[2] + '-' + parts[1] + '-' + parts[0]);
      } else {
        keys.push(parts[2] + '-' + parts[1] + '-' + parts[0]);
      }
    }
    return keys;
  }

  function listHasDate(list, dateOrText) {
    var keys = dateKeys(dateOrText);
    return list.some(function (item) {
      return keys.indexOf(String(item).trim()) !== -1;
    });
  }

  function loadAllRules() {
    var el = document.getElementById('delivery-location-rules');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function locationKey(text) {
    var t = String(text || '').toLowerCase();
    if (t.indexOf('johor') !== -1) return 'johor';
    if (t.indexOf('penang') !== -1) return 'penang';
    if (t.indexOf('ipoh') !== -1) return 'ipoh';
    if (t.indexOf('seremban') !== -1) return 'seremban';
    if (t.indexOf('selangor') !== -1 || /\bkl\b/.test(t) || t.indexOf('kl/') !== -1) return 'selangor';
    return '';
  }

  function buildLocationRules(key) {
    var raw = loadAllRules()[key] || {};
    var full = parseDates(raw.full);
    var morning = parseDates(raw.morning);
    var afternoon = parseDates(raw.afternoon);
    var slotMap = parseSlotLines(raw.slots);
    Object.keys(slotMap).forEach(function (dateKey) {
      if (slotMap[dateKey].indexOf('*') !== -1 && full.indexOf(dateKey) === -1) {
        full.push(dateKey);
      }
    });
    return { full: full, morning: morning, afternoon: afternoon, slotMap: slotMap };
  }

  function isClosedFull(dateOrText, locRules) {
    if (!locRules) return false;
    return listHasDate(locRules.full || [], dateOrText);
  }

  function closedSlotsForDate(dateOrText, locRules) {
    var closed = {};
    if (!locRules) return closed;
    if (listHasDate(locRules.morning || [], dateOrText)) {
      closed['9am - 12pm'] = true;
    }
    if (listHasDate(locRules.afternoon || [], dateOrText)) {
      closed['9am - 12pm'] = true;
      closed['12pm - 3pm'] = true;
    }
    var keys = dateKeys(dateOrText);
    keys.forEach(function (key) {
      var slots = (locRules.slotMap && locRules.slotMap[key]) || [];
      slots.forEach(function (slot) {
        if (slot === '*') {
          SLOTS.forEach(function (label) {
            closed[label] = true;
          });
        } else {
          closed[slot] = true;
        }
      });
    });
    return closed;
  }

  function slotValue(li) {
    return (
      (li.getAttribute && (li.getAttribute('data-slot-value') || li.getAttribute('rel'))) ||
      li.textContent ||
      ''
    ).trim();
  }

  function applySlotCloses(lis, dateOrText, locRules) {
    var closed = closedSlotsForDate(dateOrText, locRules);
    Array.prototype.forEach.call(lis, function (li) {
      var label = slotValue(li);
      if (closed[label]) {
        li.classList.add('disabled');
        li.classList.remove('active');
      }
    });
  }

  function startDate(opts) {
    opts = opts || {};
    var cutoffHour = parseInt(opts.cutoffHour, 10);
    if (isNaN(cutoffHour)) cutoffHour = 16;
    var preorderDays = parseInt(opts.preorderDays, 10) || 0;
    var locRules = opts.locRules;
    var now = new Date();
    var start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var extra = preorderDays;
    if (now.getHours() >= cutoffHour) extra += 1;
    start.setDate(start.getDate() + extra);
    var guard = 0;
    while (isClosedFull(start, locRules) && guard < 30) {
      start.setDate(start.getDate() + 1);
      guard += 1;
    }
    return start;
  }

  return {
    SLOTS: SLOTS,
    pad: pad,
    toYmd: toYmd,
    toDmy: toDmy,
    parseDates: parseDates,
    locationKey: locationKey,
    buildLocationRules: buildLocationRules,
    isClosedFull: isClosedFull,
    closedSlotsForDate: closedSlotsForDate,
    applySlotCloses: applySlotCloses,
    startDate: startDate,
  };
})();
